<template>

    <div class="canvas::editor-website-editors-input-MarginInput">
        <accordion-input :accordion="accordion" :spacing="spacing" :open="open">
            <template #label>

                <div class="font-medium">Marge</div>

            </template>
            <template #content>

                <small class="block mb-5 text-gray-500 text-muted">
                    Dit is de (wit)ruimte tussen blokken aan de boven- en onderkant.
                </small>

                <div class="grid grid-cols-2 gap-4">
                    <div v-for="(label, direction) in {
                        'top': 'Bovenkant',
                        'left': 'Linkerkant',
                        'bottom': 'Onderkant',
                        'right': 'Rechterkant',
                    }">
                        <div class="form-group relative">
                            <label class="-mt-0.5 absolute bg-white leading-none ml-2 px-1 text-gray-500 text-xs">{{ label }}</label>
                            <div class="-translate-y-1/2 absolute left-0 ml-3 mt-0.5 top-1/2 transform w-5'">
                                <svg v-if="direction === 'top'" class="w-5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="125" height="125" viewBox="0 0 125 125">
                                    <defs>
                                        <clipPath id="clip-top-margin">
                                            <rect width="125" height="125"/>
                                        </clipPath>
                                    </defs>
                                    <g id="top-margin" clip-path="url(#clip-top-margin)">
                                        <rect width="125" height="125" fill="rgba(255,255,255,0)"/>
                                        <g id="Group_20" data-name="Group 20" transform="translate(-1182 -571)">
                                            <path id="Path_7" data-name="Path 7" d="M13.074,0H94.789c7.221,0,13.074,6.142,13.074,13.718V24.007H0V13.718C0,6.142,5.854,0,13.074,0Z" transform="translate(1190.365 577)" fill="#5047e4"/>
                                            <path id="Path_14" data-name="Path 14" d="M13.718,0h85.74c7.576,0,13.718,5.854,13.718,13.074V22.88H0V13.074C0,5.854,6.142,0,13.718,0Z" transform="translate(1190 690.177) rotate(-90)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_15" data-name="Path 15" d="M13.718,0h85.74c7.576,0,13.718,5.854,13.718,13.074V22.88H0V13.074C0,5.854,6.142,0,13.718,0Z" transform="translate(1298.228 577) rotate(90)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_16" data-name="Path 16" d="M13.074,0H94.789c7.221,0,13.074,6.142,13.074,13.718V24.007H0V13.718C0,6.142,5.854,0,13.074,0Z" transform="translate(1298.228 690.177) rotate(180)" fill="rgba(137,137,137,0.2)"/>
                                        </g>
                                    </g>
                                </svg>
                                <svg v-if="direction === 'bottom'" class="w-5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
                                    <defs>
                                        <clipPath id="clip-margin-bottom">
                                            <rect width="100" height="100"/>
                                        </clipPath>
                                    </defs>
                                    <g id="margin-bottom" clip-path="url(#clip-margin-bottom)">
                                        <rect width="100" height="100" fill="rgba(255,255,255,0)"/>
                                        <g id="Group_22" data-name="Group 22" transform="translate(-53.949 -192)">
                                            <path id="Path_7" data-name="Path 7" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(142.598 280.648) rotate(180)" fill="#5048e4"/>
                                            <path id="Path_14" data-name="Path 14" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(65.949 280.648) rotate(-90)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_17" data-name="Path 17" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(66.208 204)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_15" data-name="Path 15" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(142.597 204) rotate(90)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_16" data-name="Path 16" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(142.857 280.648) rotate(180)" fill="rgba(80,72,228,0.2)"/>
                                        </g>
                                    </g>
                                </svg>
                                <svg v-if="direction === 'left'" class="w-5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
                                    <defs>
                                        <clipPath id="clip-margin-left">
                                            <rect width="100" height="100"/>
                                        </clipPath>
                                    </defs>
                                    <g id="margin-left" clip-path="url(#clip-margin-left)">
                                        <rect width="100" height="100" fill="rgba(255,255,255,0)"/>
                                        <g id="Group_23" data-name="Group 23" transform="translate(-53.949 -192)">
                                            <path id="Path_7" data-name="Path 7" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(65.949 280.648) rotate(-90)" fill="#5048e4"/>
                                            <path id="Path_14" data-name="Path 14" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(65.949 280.648) rotate(-90)" fill="rgba(80,72,228,0.2)"/>
                                            <path id="Path_17" data-name="Path 17" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(66.208 204)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_15" data-name="Path 15" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(142.597 204) rotate(90)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_16" data-name="Path 16" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(142.857 280.648) rotate(180)" fill="rgba(137,137,137,0.2)"/>
                                        </g>
                                    </g>
                                </svg>
                                <svg v-if="direction === 'right'" class="w-5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
                                    <defs>
                                        <clipPath id="clip-margin-right">
                                            <rect width="100" height="100"/>
                                        </clipPath>
                                    </defs>
                                    <g id="margin-right" clip-path="url(#clip-margin-right)">
                                        <rect width="100" height="100" fill="rgba(255,255,255,0)"/>
                                        <g id="Group_21" data-name="Group 21" transform="translate(-53.949 -192)">
                                            <path id="Path_7" data-name="Path 7" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(142.857 204) rotate(90)" fill="#5048e4"/>
                                            <path id="Path_14" data-name="Path 14" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(65.949 280.648) rotate(-90)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_17" data-name="Path 17" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(66.208 204)" fill="rgba(137,137,137,0.2)"/>
                                            <path id="Path_15" data-name="Path 15" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(142.857 204) rotate(90)" fill="rgba(80,72,228,0.2)"/>
                                            <path id="Path_16" data-name="Path 16" d="M9.291,0H67.358a9.291,9.291,0,0,1,9.291,9.291v6.968H0V9.291A9.291,9.291,0,0,1,9.291,0Z" transform="translate(142.857 280.648) rotate(180)" fill="rgba(137,137,137,0.2)"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <select
                                class="border border-gray-300 border-solid ease-in-out focus:border-indigo-600 focus:outline-none focus:shadow-outline-blue form-control form-input mt-1 pl-10 pr-3 py-4 rounded-md sm:leading-5 sm:text-sm transition w-full"
                                @input="$set(options, 'padding_' + direction, $event.target.value)"
                                v-model="options['padding_' + direction]"
                            >
                                <option v-for="option in margins" :value="option.padding[direction]" :selected="option.label == 'none'">
                                    {{ option.text }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

            </template>
        </accordion-input>
    </div>

</template>

<script>

import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";

export default {

    components: {
        AccordionInput
    },

    props: {
        options: Object,

        spacing: {
            horizontal: {
                type: Boolean,
                default: true
            },
            vertical: {
                type: Boolean,
                default: true
            }
        },

        accordion: {
            type: Boolean,
            default: true
        },

        open: {
            type: Boolean,
            default: null
        },
    },

    data()
    {
        let paddingSizes = {
            small: {
                xs: 2,
                md: 4,
                horizontal: {
                    // TODO Low: Sizes here currently don't do anything since we compile from Canvas/../block.scss
                    lg: 20
                }
            },
            medium: {
                xs: 4,
                md: 8,
                horizontal: {
                    lg: 52
                }
            },
            large: {
                xs: 8,
                md: 16,
                horizontal: {
                    lg: 72
                }
            },
            larger: {
                xs: 12,
                md: 24,
                horizontal: {
                    lg: 84
                }
            },
            extra_large: {
                xs: 16,
                md: 32,
                horizontal: {
                    lg: 96
                }
            },
        };

        return {
            isOpen: this.open || true,

            tailwindClassesToCompile: [
                'pt-2', 'md:pt-4',
                'pt-4', 'md:pt-8',
                'pt-8', 'md:pt-16',
                'pt-12', 'md:pt-24',
                'pt-16', 'md:pt-32',

                'pl-2', 'md:pl-4',
                'pl-4', 'md:pl-8',
                'pl-8', 'md:pl-16',
                'pl-12', 'md:pl-24',
                'pl-16', 'md:pl-32',

                'pr-2', 'md:pr-4',
                'pr-4', 'md:pr-8',
                'pr-8', 'md:pr-16',
                'pr-12', 'md:pr-24',
                'pr-16', 'md:pr-32',

                'pb-2', 'md:pb-4',
                'pb-4', 'md:pb-8',
                'pb-8', 'md:pb-16',
                'pb-12', 'md:pb-24',
                'pb-16', 'md:pb-32',
            ],

            // TODO Medium: Read TW prefix from tailwind.config.website.js
            margins: [
                {
                    'text': 'Geen',

                    // TODO Low: Delete this when all margin values have been converted in the latest Galaxy?
                    'value': 'size:none',

                    label: 'none',
                    padding: {
                        top: 'top_size:none',
                        left: 'left_size:none',
                        right: 'right_size:none',
                        bottom: 'bottom_size:none',
                    }
                },
                {
                    'text': 'Klein',

                    // Value for old margins
                    // TODO Low: Delete this when all margin values have been converted in the latest Galaxy?
                    'value': 'py-2 md:py-4 size:small',

                    // Value for new margins
                    label: 'small',
                    padding: this.paddingSizesToValues(paddingSizes, 'small'),
                },
                {
                    'text': 'Middel',

                    // TODO Low: Delete this when all margin values have been converted in the latest Galaxy?
                    'value': 'py-4 md:py-8 size:medium',

                    // Value for new margins
                    label: 'medium',
                    padding: this.paddingSizesToValues(paddingSizes, 'medium'),
                },
                {
                    'text': 'Middel groot',

                    // TODO Low: Delete this when all margin values have been converted in the latest Galaxy?
                    'value': 'py-8 md:py-16 size:large',

                    // Value for new margins
                    label: 'large',
                    padding: this.paddingSizesToValues(paddingSizes, 'large'),
                },
                {
                    'text': 'Groot',

                    // TODO Low: Delete this when all margin values have been converted in the latest Galaxy?
                    'value': 'py-12 md:py-24 size:large',

                    // Value for new margins
                    label: 'larger',
                    padding: this.paddingSizesToValues(paddingSizes, 'larger'),
                },
                {
                    'text': 'Extra groot',

                    // TODO Low: Delete this when all margin values have been converted in the latest Galaxy?
                    'value': 'py-16 md:py-32 size:extra-large',

                    // Value for new margins
                    label: 'extra_large',
                    padding: this.paddingSizesToValues(paddingSizes, 'extra_large'),
                },
            ],

            horizontalMargins: [
                {
                    'text': 'Geen',
                    'value': 'horizontal-margin-size:none',
                },
                {
                    'text': 'Klein',
                    'value': 'horizontal-margin-size:small',
                },
                {
                    'text': 'Middel',
                    'value': 'horizontal-margin-size:medium',
                },
                {
                    'text': 'Groot',
                    'value': 'horizontal-margin-size:large',
                },
                {
                    'text': 'Extra groot',
                    'value': 'horizontal-margin-size:extra-large',
                },
            ]
        }
    },

    created()
    {
        // TODO High: Fix code duplication.
        // TODO Low: ^ Instead of fixing the code duplication, we can remove this and the horizontal margin code
        // TODO Low:   when the old margin values no longer exist in the latest Galaxy projects
        // Automatically give a margin
        if (this.options.margin === undefined && this.options.margin !== '') {
            this.options.margin = 'py-8 md:py-16 size:large';
        }

        // Set default value for all directions (or get from older Galaxy margins)
        ['padding_top', 'padding_left', 'padding_right', 'padding_bottom'].forEach(paddingDirection => {
            this.checkForPaddingSize(paddingDirection);
        });

        // Automatically give a margin
        if (this.options.horizontalMargin === undefined && this.options.horizontalMargin !== '') {
            this.options.horizontalMargin = 'horizontal-margin-size:none';
        }
    },

    methods: {
        checkForPaddingSize(paddingKey)
        {
            let paddingDirection = paddingKey.split('_').pop(),
                isHorizontal = ['left', 'right'].some(direction => paddingKey.includes(direction)),
                isVertical = ['top', 'bottom'].some(direction => paddingKey.includes(direction));

            // Set margin based on old Galaxy "vertical" margins
            if( this.options.margin && isVertical && this.options[paddingKey] === undefined) {
                this.setOption(paddingKey, this.getNewCurrentPadding(this.options.margin, paddingDirection));
            }
            // Set margin based on old Galaxy "horizontal" margins
            else if( this.options.horizontalMargin && isHorizontal && this.options[paddingKey] === undefined) {
                this.setOption(paddingKey, this.getNewCurrentPadding(this.options.horizontalMargin, paddingDirection));
            }

            // Set top and bottom margin by default
            else if( !this.options[paddingKey] && isVertical
                && this.options[paddingKey] === undefined && this.options[paddingKey] !== ''
            ) {
                let largeMargin = this.margins.find(margin => margin.label === 'large');

                this.setOption(paddingKey, largeMargin.padding[paddingDirection]);
            }

            else if( !this.options[paddingKey] ) {
                this.setOption(paddingKey, paddingDirection + '_size:none');
            }
        },

        setOption(key, value)
        {
            // Vue 2 needs $set for reactive new properties, Vue 3 handles it natively
            if (this.$set) {
                this.$set(this.options, key, value);
            } else {
                this.options[key] = value;
            }
        },

        getNewCurrentPadding(marginOptions, paddingDirection = null)
        {
            let paddingSize = marginOptions.substring(marginOptions.lastIndexOf(':') + 1),
                // Normalize hyphens to underscores (e.g. "extra-large" → "extra_large")
                normalizedSize = paddingSize.replace(/-/g, '_'),
                paddingSelected = this.margins.find(margin => margin.label === normalizedSize);

            // If no match by label, try matching by old 'value' string
            if (!paddingSelected) {
                paddingSelected = this.margins.find(margin => margin.value === marginOptions);
            }

            // If still no match, try matching the Tailwind classes against old values
            if (!paddingSelected) {
                paddingSelected = this.margins.find(margin =>
                    margin.value && marginOptions.split(' ').every(cls => margin.value.includes(cls))
                );
            }

            // Fallback to 'large' (default)
            if (!paddingSelected) {
                paddingSelected = this.margins.find(margin => margin.label === 'large');
            }

            if( paddingDirection ) {
                return paddingSelected.padding[paddingDirection];
            }

            return paddingSelected;
        },

        paddingSizesToValues(paddingSizes, paddingSize)
        {
            // Padding needed for the following directions
            let paddingDirections = {top: '', left: '', right: '', bottom: ''},
                directionArray = Object.keys(paddingDirections);

            this.paddingSizesToValuesVertical(paddingDirections, paddingSizes, paddingSize);
            this.paddingSizesToValuesHorizontal(paddingDirections, paddingSizes, paddingSize);

            return paddingDirections;
        },

        paddingSizesToValuesVertical(paddingDirections, paddingSizes, paddingSize)
        {
            // Get padding size values and turn into some data we can use
            let paddingSizeValues = paddingSizes[paddingSize],
                paddingSizesArray = Object.keys(paddingSizeValues)
                    .filter(key => key !== 'horizontal')
                    .map(key => ({ size: key, padding: paddingSizeValues[key] }));

            // Map into object like {top: '*class', left: ...}
            ['top', 'bottom'].forEach(direction => {
                paddingDirections[direction] = [
                    paddingSizesArray.map(function (values) {
                        // Since "xs" isn't used in tailwind, we remove that here
                        let sizeIntoUnit = values['size'].replace('xs', ''),
                            directionIntoClass = 'p' + direction.charAt(0);

                        return (sizeIntoUnit ? sizeIntoUnit + ':' : '') + directionIntoClass + '-' + values['padding'];
                    }).join(' '),
                    direction + '_' + 'size:' + paddingSize,
                ].join(' ');
            });

            return paddingDirections;
        },

        paddingSizesToValuesHorizontal(paddingDirections, paddingSizes, paddingSize)
        {
            // Get padding size values and turn into some data we can use
            let paddingSizeValues = paddingSizes[paddingSize],
                paddingSizesArray = Object.keys(paddingSizeValues)
                    .map(key => ({ size: key, padding: paddingSizeValues[key] }));

            ['left', 'right'].forEach(direction => {
                paddingDirections[direction] = 'horizontal-margin-'+ direction + '-size:' + paddingSize;
            });
        },

        selectedBasedOnOldMargin(direction)
        {
            let marginSize = this.options.margin.substring(this.options.margin.indexOf(':') + 1),
                marginSelected = this.margins.find(margin => margin.label === marginSize);

            if( marginSize && marginSelected ) {
                return marginSelected['padding_' + direction];
            }

            return null;
        }
    }
}

</script>
